<div class="widget-mobile">
  <div class="position-relative">
    <img class="cog1" [src]="'images/404_cog.png' | contentAssetImage" />
    <img class="cog2" [src]="'images/404_cog.png' | contentAssetImage" />
    <img [src]="'images/404_laptop.png' | contentAssetImage" class="d-block mx-auto mt-4" style="max-width: 400px; width: 100%" />
    <h1 class="text-center text-muted">Page not found...</h1>
  </div>
</div>
